import { roomSizeForCount, TUNING } from '../../constants.js';
import { blankRelationship } from '../../sim/relationships.js';
import type { Npc, Relationship, RuntimeNpc } from '../../types.js';
import type { WorldState } from '../useSim.js';

const relKey = (a: string, b: string): string => `${a}>${b}`;

/** Add one npc to the running world. Existing ids are left unchanged. */
export function appendNpcToWorldState(
  npcs: Npc[],
  world: WorldState | null,
  rels: Map<string, Relationship>,
  npc: Npc,
): { npcs: Npc[]; world: WorldState | null } {
  if (npcs.some((n) => n.id === npc.id)) return { npcs, world };
  const next = [...npcs, npc];
  for (const other of next) {
    if (other.id === npc.id) continue;
    rels.set(relKey(npc.id, other.id), blankRelationship(npc.id, other.id));
    rels.set(relKey(other.id, npc.id), blankRelationship(other.id, npc.id));
  }
  if (!world) return { npcs: next, world };
  const size = roomSizeForCount(next.length);
  const margin = 60;
  const runtime: RuntimeNpc = {
    npcId: npc.id,
    x: margin + Math.random() * (size - 2 * margin),
    y: margin + Math.random() * (size - 2 * margin),
    dir: 'down',
    moving: true,
    vx: 0,
    vy: 0,
    speedPxS: TUNING.minSpeedPxS + Math.random() * (TUNING.maxSpeedPxS - TUNING.minSpeedPxS),
    retargetAt: 0,
    busyWith: null,
    cooldownUntil: 0,
    avoidUntil: 0,
    aloneSince: 0,
    restingBed: null,
    bedSince: 0,
    wakeAt: 0,
    pushTargetId: null,
    pushUntil: 0,
  };
  return {
    npcs: next,
    world: { ...world, size, npcs: next, runtime: [...world.runtime, runtime] },
  };
}
